import React, { Component } from 'react';
import ScrollableAnchor, { configureAnchors, goToAnchor } from 'react-scrollable-anchor'
import { push } from "../Services/Analytics"

import "./PlayBuzz.scss"
import dataJSON from "../../api/PlayBuzz.json"

class PlayBuzz extends Component {
  constructor(props) {
    super();
    this.clickedToPlay = this.clickedToPlay.bind(this);
    this.state = {
      showPlayBuzz: 0
    }
  }
  clickedToPlay() {
    push("PlayBuzz_Clicked", "");
    this.setState({
      showPlayBuzz: 1
    })
  }
  render() {
    return (
      <ScrollableAnchor id="playbuzz">
      <section className={`section section-playbuzz ${dataJSON[this.props.item].className}`}>
        <div className="container">
          <div className="play">
            <h3>{dataJSON[this.props.item].name}</h3>
            <h4>{dataJSON[this.props.item].desc}</h4>
            <div className="embed">
              <div className="poster" onClick={this.clickedToPlay} style={{ display: (this.state.showPlayBuzz ? "none" : "block") }}>
                <img src={`./static/images/desktop/${dataJSON[this.props.item].poster}`} alt="PlayBuzz" />
                <div className="button"></div>
              </div>
              <div className="game" style={{ display: (this.state.showPlayBuzz ? "block" : "none") }}>
                <div className="playbuzz" data-show-info="false" data-comments="false" data-show-share="false" data-id={dataJSON[this.props.item].embed}></div>
              </div>
              <div className="pblogo" style={{ display: (this.state.showPlayBuzz ? "none" : "block") }}>
                <div className="playbuzzLogo" style={{ display: (this.state.showPlayBuzz ? "none" : "block") }}></div>
              </div>
            </div>
          </div>
          <div className={`bottle ${(this.state.showPlayBuzz ? "clicked" : "")}`}></div>
        </div>
      </section>
      </ScrollableAnchor>
    );
  }
}

export default PlayBuzz;



// WEBPACK FOOTER //
// ./src/Components/PlayBuzz/PlayBuzz.js